<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-card>
      <div slot="header">
        <!-- <el-button style="padding: 3px 0" type="text" @click="back">
          <i class="el-icon-arrow-left"></i>
        </el-button> -->
        <el-row style="line-height: 40px">
          <el-col :span="4">
            <span style="font-size: 16px; font-weight: bold">統計排名</span>
          </el-col>
        </el-row>
      </div>

      <el-row>
        <el-col :span="6">
          <el-row type="flex" align="middle">
            <el-col :span="5">
              <h6>學年度</h6>
            </el-col>
            <el-select
              v-model="queryForm.year"
              placeholder="請選擇"
              style="display: block; width: 100%"
              @change="yearChange"
            >
              <el-option
                v-for="item in getyear"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-row>
        </el-col>

        <el-col :span="3" :offset="15">
          <el-button
            class="darkblue"
            style="float: right; margin-right: 10px"
            @click="getExcel"
            >排名總表匯出</el-button
          >
        </el-col>
      </el-row>
      <br />
      <el-tabs v-model="tabPane">
        <el-tab-pane label="全寺排名" name="all">
          <br />

          <orderTab
           :clickTime="tabTime"
           :year="queryForm.year"
           ref="tab"
          ></orderTab>

        </el-tab-pane>
        <el-tab-pane label="班級排名" name="class">
          <br />
          <el-row>
            <el-col :span="6">
              <el-input
                :prefix-icon="queryForm.qString == '' ? 'el-icon-search' : ''"
                placeholder="請輸入 學程"
                v-model="queryForm.qString"
                @keyup.enter.native="query"
              ></el-input>
            </el-col>
          </el-row>
          <el-table :data="tableData" stripe style="width: 50%">
            <el-table-column
              prop="studyClass"
              label="學程"
              header-align="center"
              align="center"
            >
                <template slot-scope="scope">
               <span>{{scope.row.studyClass}}{{scope.row.groupBy}}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="pc"
              label="人數"
              width="100"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="gotoOderByStudyYear(scope.row)"
                  >查看排名</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import API from "../../api";
// import Utils from "../../utils";
// import { InformType } from "@/utils/InformType";
import orderTab from "./component/orderTab";

export default {
  name: "orderByYear",

  components: { orderTab },
  data() {
    return {
      isLoading: false,
      tabPane: "all",
      tabTime:null,
      tableData:[],

      queryForm: {
        year: "",
        qString: "",
      },

      getyear: [],
    };
  },

  created() {
    this.getYear();
  },

  methods: {
    query() {
      console.log("讀取");
      this.isLoading = true;
      API.studyYear.query(this.queryForm).then((res) => {
        this.tableData = res.data;
        console.log(res.data);
        this.isLoading = false;
      });
    },

    yearChange(){
      this.tabTime= new Date();
      this.query();
    },

    getYear() {
      console.log("讀取年度");
      API.studyYear.getYear().then((res) => {
        this.getyear = res.data;
        this.queryForm.year = this.getyear.length > 0 ? this.getyear[0] : "";
        this.tabTime = new Date();
        this.query();
      });
      // console.log(this.year);
    },

    gotoOderByStudyYear(row) {
      this.$router.push({ path: `/orderByStudyYear?id=${row.id}&year=${this.queryForm.year}` });
    },

    getExcel() {
      this.$refs.tab.getExcel();
    },
  },
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
</style>